<template>
  <div class="advantages-container margin-general">
    <div class="items-container">
      <div class="title-container">
        <h2 v-if="title" class="title">
          {{ $t(title) }}
        </h2>
        <img
          v-if="imageSrc"
          :src="imageSrc"
          :alt="imageAlt"
        />
      </div>
      <div class="items-container-2">
        <div class="advantage" v-for="(item, index) in advantages" :key="index">
          <div class="image-container">
            <!-- <span class="material-symbols-outlined icon" translate="no">{{ item.image }}</span> -->
            <img v-if="item.image && (item.image.endsWith('.svg') || item.image.endsWith('.png') || item.image.endsWith('.jpg'))"
                 :src="item.image" :alt="item.alt || 'icono'" class="icon" loading="lazy"/>
            <span v-else class="material-symbols-outlined icon" translate="no">{{ item.image }}</span>
          </div>
          <div class="advantage-text-item">
            <p class="title body-6-bold">{{ $t(item.title) }}</p>
            <p class="description body-4">{{ $t(item.description) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  title: {
    type: String,
    required: false,
  },
  advantages: {
    type: Array,
    required: true,
  },
  imageConfig: {
    type: Object,
    required: false,
  },
  imageAlt: {
    type: String,
    required: false,
    default: 'Image not available',
  },
});

const { locale } = useI18n();

const currentLocale = computed(() => locale.value || 'default');
const imageSrc = computed(() => {
  return (
    props.imageConfig?.[currentLocale.value]?.image ||
    props.imageConfig?.default?.image ||
    null
  );
});
</script>